module.exports = __webpack_public_path__ + "/login_ui/img/down-875de65ce5d31e4e153c6a3415813c08.svg";